export enum UserLogExtendedActionEventTypes {
  ALERTS_DETAIL_PAGE_ACCESS = "Alert Details Viewed",
  ALERTS_PAGE_ACCESS = "Alerts Page Viewed",
  CAMERA_NOTES_ACCESS = "Camera Notes Viewed",
  CAMERA_OPTIONS_ACCESS = "Camera Options Viewed",
  CAMERA_PAGE_ACCESS = "Camera Page Viewed",
  CAMERA_STREAM_REQUEST_FROM_CAMERAS_PAGE = "Camera Stream Requested",
  MONITORING_ADMIN_PANEL = "Admin Panel Monitored",
  SITES_DETAIL_ACCESS_PAGE_ACCESS = "Site Access List Viewed",
  SITES_DETAIL_CAMERAS_PAGE_ACCESS = "Site Cameras Viewed",
  SITES_DETAIL_INFO_PAGE_ACCESS = "Site Info Viewed",
  SITES_DETAIL_INTEGRATIONS_PAGE_ACCESS = "Site Integrations Viewed",
  SITES_DETAIL_LANGUAGE_PAGE_ACCESS = "Site Language Settings Viewed",
  SITES_DETAIL_MAP_PAGE_ACCESS = "Site Map Viewed",
  SITES_DETAIL_MISC_PAGE_ACCESS = "Site Miscellaneous Viewed",
  SITES_DETAIL_NOTES_PAGE_ACCESS = "Site Notes Viewed",
  SITES_DETAIL_PAGE_ACCESS = "Site Details Viewed",
  SITES_DETAIL_TAGS_PAGE_ACCESS = "Site Tags Viewed",
  SITES_DETAIL_THINGS_PAGE_ACCESS = "Site Things Viewed",
  SITES_PAGE_ACCESS = "Sites Page Viewed",
  USERS_DETAIL_PAGE_ACCESS = "User Details Viewed",
  USERS_PAGE_ACCESS = "Users Page Viewed",
  PRERECORDED_AUDIO_CLICKED = "Pre-recorded audio clicked",
  RECORDING_AUDIO_STARTED = "Recording button clicked, Recording started",
  RECORDING_AUDIO_STOPPED = "Recording button clicked, Recording stopped",
}